(function () {
  'use strict';
  var dialog = document.getElementById('SSSMysteryDiscount');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  if (window.Shopify && window.Shopify.designMode) return;
  // Enable only after BOTH Omnisend forms use custom triggers and the
  // exposure/conversion collector has been connected and verified.
  if (dialog.dataset.experimentEnabled !== 'true') return;
  dialog.dataset.initialized = 'true';

  var key = 'sss_offer_ab_session_v1';
  var experiment = 'wheel_vs_mystery_v1';
  var assignmentKey = 'sss_offer_ab_assignment_v1';
  var controlFormId = dialog.dataset.controlFormId;
  var mysteryFormId = dialog.dataset.formId;
  if (!controlFormId || !mysteryFormId || controlFormId === mysteryFormId) return;

  // Preserve the current exclusion of visits from Omnisend messages across
  // navigation, for both groups. Omnisend uses utm_source=omnisend.
  var excludedKey = 'sss_offer_ab_excluded_v1';
  var source = new URLSearchParams(location.search || '').get('utm_source') || '';
  var excluded = source.toLowerCase() === 'omnisend';
  try { excluded = excluded || sessionStorage.getItem(excludedKey) === '1'; } catch (error) {}
  try { excluded = excluded || document.cookie.split(';').some(function (part) { return part.trim() === excludedKey + '=1'; }); } catch (error) {}
  if (excluded) {
    try { sessionStorage.setItem(excludedKey, '1'); } catch (error) {}
    try { document.cookie = excludedKey + '=1; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (error) {}
    return;
  }

  function readAssignment() {
    var cookie = '', stored = '';
    try {
      cookie = document.cookie.split(';').map(function (part) { return part.trim(); })
        .find(function (part) { return part.indexOf(assignmentKey + '=') === 0; }) || '';
      cookie = cookie.slice(assignmentKey.length + 1);
    } catch (error) {}
    try { stored = localStorage.getItem(assignmentKey) || ''; } catch (error) {}
    var candidates = [cookie, stored];
    for (var i = 0; i < candidates.length; i++) {
      var parts = candidates[i].split('.');
      if ((parts[0] === 'A' || parts[0] === 'B') && Number(parts[1]) > Date.now()) return candidates[i];
    }
    return '';
  }
  var assignment = readAssignment();
  if (!assignment) {
    var random = Math.random();
    if (window.crypto && window.crypto.getRandomValues) {
      random = window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;
    }
    assignment = (random < 0.5 ? 'A' : 'B') + '.' + (Date.now() + 30 * 86400000);
    try { localStorage.setItem(assignmentKey, assignment); } catch (error) {}
    try { document.cookie = assignmentKey + '=' + assignment + '; Max-Age=2592000; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (error) {}
    // Without durable assignment, a visitor could see both versions on reload.
    if (readAssignment() !== assignment) return;
  }
  var variant = assignment.charAt(0);
  var formId = variant === 'A' ? controlFormId : mysteryFormId;
  var exposed = false, submitted = false, controlRequested = false, formViewed = false;
  var qa = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main');
  try { qa = qa || sessionStorage.getItem('sss_offer_ab_qa_v1') === '1'; } catch (error) {}
  var analyticsQueue = [], analyticsTimer, analyticsAttempts = 0;

  function flushAnalytics() {
    window.clearTimeout(analyticsTimer);
    if (!analyticsQueue.length) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') {
      if (++analyticsAttempts < 30) analyticsTimer = window.setTimeout(flushAnalytics, 1000);
      return;
    }
    while (analyticsQueue.length) {
      var item = analyticsQueue.shift();
      var params = { send_to: 'G-1E9BY64FS8', experiment_id: experiment, variant: variant, form_id: formId };
      if (qa) params.debug_mode = true;
      window.gtag('event', (qa ? 'sss_ab_qa_' : 'sss_ab_') + variant.toLowerCase() + '_' + item, params);
    }
  }
  document.addEventListener('visitorConsentCollected', flushAnalytics);

  function record(name) {
    // No email, phone number, cookie contents or formValues are forwarded.
    window.dispatchEvent(new CustomEvent('sss:offer-ab', { detail: {
      event: name, experiment: experiment, variant: variant, form_id: formId
    } }));
    analyticsQueue.push(name);
    flushAnalytics();
  }
  function recordExposure() {
    if (exposed) return;
    exposed = true;
    record('offer_view');
  }
  function queueForm() {
    window.omnisend = window.omnisend || [];
    var queued = Array.isArray(window.omnisend) && window.omnisend.some(function (command) {
      return Array.isArray(command) && command[0] === 'openForm' && command[1] === formId;
    });
    if (!queued) window.omnisend.push(['openForm', formId]);
  }
  var boxes = Array.from(dialog.querySelectorAll('[data-sss-box]'));
  var status = dialog.querySelector('[data-sss-status]');
  var claim = dialog.querySelector('[data-sss-claim]');
  var revealTimer, fallbackTimer, showTimer;
  var chosen = false;
  var handoff = false;
  var finished = false;
  var activeForms = new Set();

  // Session cookie shares the dismissal between tabs; sessionStorage is a fallback.
  // Neither storage contains contact details, and the cookie has no persistent expiry.
  function readSession() {
    var local = '', cookie = '';
    try { local = sessionStorage.getItem(key) || ''; } catch (error) {}
    try { cookie = document.cookie.split('; ').find(function (part) { return part.indexOf(key + '=') === 0; }) || ''; } catch (error) {}
    cookie = cookie.slice(key.length + 1);
    if (local === 'seen' || cookie === 'seen') return 'seen';
    return local || cookie;
  }
  function writeSession(value) {
    try { sessionStorage.setItem(key, value); } catch (error) {}
    try { document.cookie = key + '=' + value + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (error) {}
  }
  var session = readSession();
  if (session === 'seen') return;
  var arrival = Number(session);
  if (!arrival || arrival > Date.now()) {
    arrival = Date.now() - Math.min(performance.now(), 20000);
    writeSession(String(arrival));
  }

  function isVisible(element) {
    if (!element || element.closest('[hidden], details:not([open])')) return false;
    if (element.checkVisibility) return element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    return !!(element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0');
  }
  function anotherModalIsOpen() {
    if (activeForms.size) return true;
    return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], #Q4Bogo.is-open, cart-drawer.active, .popup-modal--active, details[open].menu-drawer-container, #shopify-pc__banner')).some(function (element) {
      return element !== dialog && !dialog.contains(element) && isVisible(element);
    });
  }
  function show() {
    if (finished || readSession() === 'seen') return;
    if (document.visibilityState !== 'visible' || anotherModalIsOpen()) {
      showTimer = window.setTimeout(show, 1000);
      return;
    }
    if (variant === 'A') {
      if (controlRequested) return;
      controlRequested = true;
      writeSession('seen');
      try { queueForm(); } catch (error) { record('form_error'); }
      return;
    }
    dialog.showModal();
    document.documentElement.classList.add('sss-mystery-lock');
    writeSession('seen');
    recordExposure();
    dialog.querySelector('[data-sss-close]').focus({ preventScroll: true });
  }
  function hide() {
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('sss-mystery-lock');
  }
  function dismiss() {
    finished = true;
    handoff = false;
    window.clearTimeout(revealTimer);
    window.clearTimeout(fallbackTimer);
    window.clearTimeout(showTimer);
    hide();
  }
  function showFallback() {
    if (finished || !handoff) return;
    handoff = false;
    status.textContent = 'Your 18% OFF is unlocked. Tap below to open the signup form.';
    claim.hidden = false;
    // Do not place our dialog above another app or a customer's cart.
    if (anotherModalIsOpen()) return;
    dialog.showModal();
    document.documentElement.classList.add('sss-mystery-lock');
    claim.focus({ preventScroll: true });
  }
  function openForm() {
    if (finished || handoff) return;
    handoff = true;
    hide();
    fallbackTimer = window.setTimeout(showFallback, 8000);
    try {
      queueForm();
    } catch (error) {
      window.clearTimeout(fallbackTimer);
      showFallback();
    }
  }
  boxes.forEach(function (box) {
    box.addEventListener('click', function () {
      if (chosen) return;
      chosen = true;
      record('box_reveal');
      boxes.forEach(function (item) { item.disabled = true; });
      box.classList.add('is-selected');
      dialog.classList.add('is-revealed');
      box.setAttribute('aria-label', '18% OFF unlocked');
      box.querySelector('.sss-mystery__pick').textContent = 'UNLOCKED';
      status.textContent = "YOU’VE UNLOCKED 18% OFF — opening your signup form…";
      dialog.querySelector('[data-sss-close]').focus({ preventScroll: true });
      revealTimer = window.setTimeout(openForm, 1800);
    });
  });
  claim.addEventListener('click', openForm);
  dialog.querySelectorAll('[data-sss-close]').forEach(function (button) { button.addEventListener('click', dismiss); });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  window.addEventListener('omnisendForms', function (event) {
    var detail = event.detail || {};
    var form = detail.form || {};
    var eventName = detail.eventName || detail.type;
    var requested = variant === 'A' ? controlRequested : chosen;
    if (form.id === formId && requested) {
      if (eventName === 'view') {
        if (variant === 'A') recordExposure();
        if (!formViewed) { formViewed = true; record('form_view'); }
      }
      if (eventName === 'submit' && exposed && !submitted) {
        submitted = true;
        record('form_submit');
      }
    }
    if (form.displayType === 'popup' || form.displayType === 'flyout') {
      if (eventName === 'view') activeForms.add(form.id);
      if (eventName === 'close') activeForms.delete(form.id);
    }
    if (form.id === formId && eventName === 'view' && chosen) {
      window.clearTimeout(fallbackTimer);
      finished = true;
      handoff = false;
      hide();
    }
  });
  window.addEventListener('pagehide', function () { dismiss(); });
  // A visitor who returns from the back/forward cache before the offer appeared
  // still receives it, while a dismissed offer stays dismissed.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && readSession() !== 'seen') { finished = false; show(); }
  });
  showTimer = window.setTimeout(show, Math.max(0, 20000 - (Date.now() - arrival)));
})();
